<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_7318_63473)">
      <path
        d="M10.0009 5.25488L2.86798 11.1352C2.86798 11.1435 2.8659 11.1557 2.86173 11.1724C2.85764 11.1889 2.85547 11.2009 2.85547 11.2094V17.1638C2.85547 17.3788 2.93407 17.5652 3.09123 17.7221C3.24835 17.879 3.4344 17.958 3.64943 17.958H8.41288V13.1943H11.589V17.9582H16.3524C16.5674 17.9582 16.7537 17.8794 16.9106 17.7221C17.0677 17.5653 17.1466 17.3789 17.1466 17.1638V11.2094C17.1466 11.1764 17.1421 11.1514 17.1341 11.1352L10.0009 5.25488Z"
        fill="#8B90A4"
      />
      <path
        d="M19.8621 9.79542L17.1455 7.53766V2.47628C17.1455 2.36057 17.1083 2.26541 17.0336 2.19094C16.9596 2.11655 16.8644 2.07936 16.7485 2.07936H14.3667C14.2509 2.07936 14.1558 2.11655 14.0812 2.19094C14.0069 2.26541 13.9697 2.36061 13.9697 2.47628V4.89528L10.9429 2.36452C10.6786 2.14949 10.3642 2.04199 10.0003 2.04199C9.63641 2.04199 9.32214 2.14949 9.05752 2.36452L0.137848 9.79542C0.0551625 9.86146 0.00984397 9.95036 0.00141463 10.062C-0.00697126 10.1736 0.0219231 10.2711 0.0881847 10.3537L0.857297 11.2717C0.923558 11.3461 1.01028 11.3916 1.11782 11.4082C1.21711 11.4166 1.31639 11.3876 1.41568 11.3214L10 4.16336L18.5845 11.3214C18.6508 11.3791 18.7375 11.4079 18.845 11.4079H18.8823C18.9897 11.3916 19.0762 11.3458 19.1428 11.2716L19.912 10.3537C19.9782 10.2709 20.0071 10.1736 19.9985 10.0619C19.9901 9.95049 19.9446 9.8616 19.8621 9.79542Z"
        fill="#8B90A4"
      />
    </g>
    <defs>
      <clipPath id="clip0_7318_63473">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
